import { render, staticRenderFns } from "./BusinessAddresses.vue?vue&type=template&id=312a839b&scoped=true&"
import script from "./BusinessAddresses.vue?vue&type=script&lang=js&"
export * from "./BusinessAddresses.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAddresses.vue?vue&type=style&index=0&id=312a839b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a839b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VContainer,VRow,VTab,VTabs,VTabsItems,VTooltip})
